export const employees = [
  {
    id: 1,
    name: "Cole Ashbury",
    designation: "Software Engineer",
    department: "Engineering",
    profile_image: "/public/images/employees/company-employee-1.png",
    phone_number: "(728) 521-2584",
    engagement: 500,
    workAnniversary: "May 22",
    birthday: "September 29",
    jobsDone: 15,
    thankYou: 97,
    congrats: 120,
    office_tel: "(728) 192-5945 Ext: 194",
    email: "cashbury@company.com",
    sex: "Male",
    city: "New York",
  },
  {
    id: 2,
    name: "Joshua Baker",
    designation: "Accountant",
    department: "Accounting",
    profile_image: "/public/images/employees/company-employee-6.png",
    phone_number: "(404) 153-5520",
    engagement: 100,
    workAnniversary: "May 22",
    birthday: "September 29",
    jobsDone: 15,
    thankYou: 97,
    congrats: 120,
    office_tel: "(728) 192-5945 Ext: 194",
    email: "jbaker@company.com",
    sex: "Male",
    city: "New York",
  },
  {
    id: 3,
    name: "Dylan Baylidge",
    designation: "Sales Consultant",
    department: "Sales",
    profile_image: "/public/images/employees/company-employee-4.png",
    phone_number: "(404) 192-5945",
    engagement: 15,
    workAnniversary: "May 22",
    birthday: "September 29",
    jobsDone: 15,
    thankYou: 97,
    congrats: 120,
    office_tel: "(728) 192-5945 Ext: 194",
    email: "dabylidge@company.com",
    sex: "Male",
    city: "New York",
  },
  {
    id: 4,
    name: "Lisa Bradford",
    designation: "Communication Manager",
    department: "Marketing",
    profile_image: "/public/images/employees/company-employee-5.png",
    phone_number: "(320) 923-4811",
    engagement: 125,
    workAnniversary: "May 22",
    birthday: "September 29",
    jobsDone: 15,
    thankYou: 97,
    congrats: 120,
    office_tel: "(728) 192-5945 Ext: 194",
    email: "lbradford@company.com",
    sex: "Female",
    city: "New York",
  },
  {
    id: 5,
    name: "Paul Brent",
    designation: "Financial Supervisor",
    department: "Finance",
    profile_image: "/public/images/employees/company-employee-3.png",
    phone_number: "(404) 875-3439",
    engagement: 450,
    workAnniversary: "May 22",
    birthday: "September 29",
    jobsDone: 15,
    thankYou: 97,
    congrats: 120,
    office_tel: "(728) 192-5945 Ext: 194",
    email: "pbrent@company.com",
    sex: "Male",
    city: "New York",
  },
  {
    id: 6,
    name: "Taylor Christensen",
    designation: "Product Designer",
    department: "Design",
    profile_image: "/public/images/employees/company-employee-2.png",
    phone_number: "(404) 650-3953",
    engagement: 72,
    workAnniversary: "May 22",
    birthday: "September 29",
    jobsDone: 15,
    thankYou: 97,
    congrats: 120,
    office_tel: "(728) 192-5945 Ext: 194",
    email: "tchristensen@company.com",
    sex: "Male",
    city: "New York",
  },
  {
    id: 7,
    name: "Lisa Bradford",
    designation: "Communication Manager",
    department: "Sales",
    profile_image: "/public/images/employees/company-employee-5.png",
    phone_number: "(320) 923-4811",
    engagement: 72,
    workAnniversary: "May 22",
    birthday: "September 29",
    jobsDone: 15,
    thankYou: 97,
    congrats: 120,
    office_tel: "(728) 192-5945 Ext: 194",
    email: "lbradford@company.com",
    sex: "Female",
    city: "New York",
  },
  {
    id: 8,
    name: "Paul Brent",
    designation: "Financial Supervisor",
    department: "Finance",
    profile_image: "/public/images/employees/company-employee-3.png",
    phone_number: "(404) 875-3439",
    engagement: 450,
    workAnniversary: "May 22",
    birthday: "September 29",
    jobsDone: 15,
    thankYou: 97,
    congrats: 120,
    office_tel: "(728) 192-5945 Ext: 194",
    email: "pbrent@company.com",
    sex: "Male",
    city: "New York",
  },
  {
    id: 9,
    name: "Taylor Christensen",
    designation: "Product Designer",
    department: "Design",
    profile_image: "/public/images/employees/company-employee-2.png",
    phone_number: "(404) 650-3953",
    engagement: 72,
    workAnniversary: "May 22",
    birthday: "September 29",
    jobsDone: 15,
    thankYou: 97,
    congrats: 120,
    office_tel: "(728) 192-5945 Ext: 194",
    email: "tchristensen@company.com",
    sex: "Male",
    city: "New York",
  },
  {
    id: 10,
    name: "Cole Ashbury",
    designation: "Software Engineer",
    department: "Finance",
    profile_image: "/public/images/employees/company-employee-1.png",
    phone_number: "(728) 521-2584",
    engagement: 500,
    workAnniversary: "May 22",
    birthday: "September 29",
    jobsDone: 15,
    thankYou: 97,
    congrats: 120,
    office_tel: "(728) 192-5945 Ext: 194",
    email: "cashbury@company.com",
    sex: "Male",
    city: "New York",
  },
  {
    id: 11,
    name: "Joshua Baker",
    designation: "Accountant",
    department: "Engineering",
    profile_image: "/public/images/employees/company-employee-6.png",
    phone_number: "(404) 153-5520",
    engagement: 100,
    workAnniversary: "May 22",
    birthday: "September 29",
    jobsDone: 15,
    thankYou: 97,
    congrats: 120,
    office_tel: "(728) 192-5945 Ext: 194",
    email: "jbaker@company.com",
    sex: "Male",
    city: "New York",
  },
  {
    id: 12,
    name: "Dylan Baylidge",
    designation: "Sales Consultant",
    department: "Marketing",
    profile_image: "/public/images/employees/company-employee-4.png",
    phone_number: "(404) 192-5945",
    engagement: 15,
    workAnniversary: "May 22",
    birthday: "September 29",
    jobsDone: 15,
    thankYou: 97,
    congrats: 120,
    office_tel: "(728) 192-5945 Ext: 194",
    email: "dabylidge@company.com",
    sex: "Male",
    city: "New York",
  },
  {
    id: 13,
    name: "Lisa Bradford",
    designation: "Communication Manager",
    department: "Engineering",
    profile_image: "/public/images/employees/company-employee-5.png",
    phone_number: "(320) 923-4811",
    engagement: 72,
    workAnniversary: "May 22",
    birthday: "September 29",
    jobsDone: 15,
    thankYou: 97,
    congrats: 120,
    office_tel: "(728) 192-5945 Ext: 194",
    email: "lbradford@company.com",
    sex: "Female",
    city: "New York",
  },
  {
    id: 14,
    name: "Paul Brent",
    designation: "Financial Supervisor",
    department: "Finance",
    profile_image: "/public/images/employees/company-employee-3.png",
    phone_number: "(404) 875-3439",
    engagement: 450,
    workAnniversary: "May 22",
    birthday: "September 29",
    jobsDone: 15,
    thankYou: 97,
    congrats: 120,
    office_tel: "(728) 192-5945 Ext: 194",
    email: "pbrent@company.com",
    sex: "Male",
    city: "New York",
  },
  {
    id: 15,
    name: "Lisa Bradford",
    designation: "Communication Manager",
    department: "Finance",
    profile_image: "/public/images/employees/company-employee-5.png",
    phone_number: "(320) 923-4811",
    engagement: 72,
    workAnniversary: "May 22",
    birthday: "September 29",
    jobsDone: 15,
    thankYou: 97,
    congrats: 120,
    office_tel: "(728) 192-5945 Ext: 194",
    email: "lbradford@company.com",
    sex: "Female",
    city: "New York",
  },
  {
    id: 16,
    name: "Paul Brent",
    designation: "Financial Supervisor",
    department: "Finance",
    profile_image: "/public/images/employees/company-employee-3.png",
    phone_number: "(404) 875-3439",
    engagement: 450,
    workAnniversary: "May 22",
    birthday: "September 29",
    jobsDone: 15,
    thankYou: 97,
    congrats: 120,
    office_tel: "(728) 192-5945 Ext: 194",
    email: "pbrent@company.com",
    sex: "Male",
    city: "New York",
  },
  {
    id: 17,
    name: "Dylan Baylidge",
    designation: "Sales Consultant",
    department: "Finance",
    profile_image: "/public/images/employees/company-employee-4.png",
    phone_number: "(404) 192-5945",
    engagement: 15,
    workAnniversary: "May 22",
    birthday: "September 29",
    jobsDone: 15,
    thankYou: 97,
    congrats: 120,
    office_tel: "(728) 192-5945 Ext: 194",
    email: "dabylidge@company.com",
    sex: "Male",
    city: "New York",
  },
];

export const muscleGroup = [
  {
    id: "none",
    category_name: "None",
  },
  {
    id: 1,
    category_name: "Back",
  },
  {
    id: 2,
    category_name: "Core",
  },
  {
    id: 3,
    category_name: "Hips",
  },
  {
    id: 4,
    category_name: "Legs",
  },
  {
    id: 5,
    category_name: "Shoulder",
  },
  {
    id: 6,
    category_name: "Chest",
  },
  {
    id: 7,
    category_name: "Arms",
  },
  {
    id: 8,
    category_name: "Upper Body",
  },
  {
    id: 9,
    category_name: "Lower Body",
  },
  {
    id: 10,
    category_name: "Total Body",
  },
  {
    id: 11,
    category_name: "Mindfulness",
  },
  {
    id: 12,
    category_name: "Mental Health",
  },
];

export const fitnessLevel = [
  {
    id: "none",
    category_name: "None",
  },
  {
    id: 1,
    category_name: "Beginner",
  },
  {
    id: 2,
    category_name: "Intermediate",
  },
  {
    id: 3,
    category_name: "Advanced",
  },
];

export const updatedTierPoints = [
  { key: "Tier 1: 0 points", value: 0 },
  { key: "Tier 2: 25 points", value: 25 },
  { key: "Tier 3: 50 points", value: 50 },
  { key: "Tier 4: 100 points", value: 100 },
  { key: "Tier 5: 150 points", value: 150 },
  { key: "Tier 6: 200 points", value: 200 },
  { key: "Tier 7: 250 points", value: 250 },
  { key: "Tier 8: 300 points", value: 300 },
  { key: "Tier 9: 350 points", value: 350 },
  { key: "Tier 10: 400 points", value: 400 },
  { key: "Tier 11: 450 points", value: 450 },
  { key: "Tier 12: 500 points", value: 500 },
  { key: "Tier 13: 550 points", value: 550 },
  { key: "Tier 14: 600 points", value: 600 },
  { key: "Tier 15: 650 points", value: 650 },
  { key: "Tier 16: 700 points", value: 700 },
  { key: "Tier 17: 750 points", value: 750 },
  { key: "Tier 18: 800 points", value: 800 },
  { key: "Tier 19: 850 points", value: 850 },
  { key: "Tier 20: 900 points", value: 900 },
  { key: "Tier 21: 950 points", value: 950 },
  { key: "Tier 22: 1000 points", value: 1000 },
];

export const showChallengeEmailNotificationInfo = [
  "Emails will be sent as soon as you click Create Challenge.",
  "Email reminders will be sent the day before a challenge starts at 12pm noon.",
  "Email notifications are sent the day after a challenge is completed to users who participated.",
];

export const challengeLevel = ["Beginner", "Intermediate", "Advanced"];

export const biometricFormFields = [
  {
    title: "first",
    inputFields: [
      {
        type: "text",
        placeholder: "First Name",
        name: "fname",
        label: "First Name",
        maxLength: 30,
      },
      {
        type: "text",
        placeholder: "Last Name",
        name: "lname",
        label: "Last Name",
        maxLength: 30,
      },
      {
        type: "text",
        placeholder: "Work Email",
        name: "mail",
        label: "Email",
        maxLength: 50,
      },
      { name: "birthday", label: "Birthday" },
      {
        type: "text",
        placeholder: "Employer",
        name: "companyName",
        label: "Company Name",
      },
    ],
  },
  {
    title: "second",
    inputFields: [
      {
        type: "text",
        placeholder: "Phone (Optional)",
        name: "phoneNumber",
        label: "Phone Number",
      },
      { type: "text", placeholder: "City", name: "city", label: "City" },
      { type: "text", placeholder: "State", name: "state", label: "State" },
      {
        type: "text",
        placeholder: "Address",
        name: "address1",
        label: "Address",
      },
      {
        type: "text",
        placeholder: "Zip code",
        name: "postalCode",
        label: "Postal Code",
        maxLength: 6,
      },
      { name: "gender", label: "Gender" },
    ],
  },
];

export const personaldetails = [
  {
    title: "first",
    inputFields: [
      { type: "text", placeholder: "Height", name: "height", label: "Height" },
      {
        type: "text",
        placeholder: "Weight",
        name: "weight",
        label: "Weight (LBS)",
      },
      { type: "text", placeholder: "BMI", name: "bmi", label: "BMI" },
      {
        type: "text",
        placeholder: "Systolic Blood Pressure",
        name: "bloodPressureSys",
        label: "Systolic Blood Pressure (mm/Hg)",
      },
      {
        type: "text",
        placeholder: "Diastolic Blood Pressure",
        name: "bloodPressureDia",
        label: "Diastolic Blood Pressure (mm/Hg)",
      },
    ],
  },
  {
    title: "second",
    inputFields: [
      { name: "fasting" },
      {
        type: "text",
        placeholder: "HDL Cholesterol",
        name: "cholestrolHdl",
        label: "HDL Cholesterol (mg/dl)",
      },
      {
        type: "text",
        placeholder: "LDL Cholesterol",
        name: "cholestrolLdl",
        label: "LDL Cholesterol (mg/dl)",
      },
      {
        type: "text",
        placeholder: "Triglycerides",
        name: "triglycerides",
        label: "Triglycerides (mg/dl)",
      },
      {
        type: "text",
        placeholder: "Glucose",
        name: "glucose",
        label: "Glucose (mg/dl)",
      },
      {
        type: "text",
        placeholder: "Waist Circumference (Optional)",
        name: "waistCircumference",
        label: "Waist Circumference (IN)",
      },
    ],
  },
];

export const totalMembers = {
  content: "Total Members",
  value: 123500,
  svg: "M12.48,1.41c-0.5,0 -0.43,0.15 -0.7,0.18c-0.27,0.04 0.05,-0.04 -0.76,0.11c-0.81,0.15 -1.1,1.13 -1.14,1.5c-0.04,0.36 -0.14,1.42 -0.11,1.97c0.08,0.33 -0.45,0.33 -0.45,0.33c-0.49,-0.03 -0.33,1.4 -0.33,1.4c0.07,0.35 0.04,0.53 0.76,0.8c0.34,0.92 1.59,1.39 1.59,1.39c0,0 0.04,0.59 0.06,1.01c-0.07,-0.03 0.39,1.08 -1.85,1.39c-2.24,0.31 -2.6,1.16 -2.68,1.38c-0.33,0.76 -0.34,3.14 -0.34,3.14l12.96,-0.02c0,0 0.02,-2.74 -0.4,-3.12c-0.42,-0.38 -0.55,-1.06 -2.79,-1.38c-2.03,-0.25 -1.65,-1.39 -1.66,-1.46c0,-0.17 0.01,-0.87 0.01,-0.87c0,0 1.12,-0.57 1.46,-1.49c0.54,-0.32 0.75,-0.37 0.83,-0.74c0,0 0.05,-1.4 -0.53,-1.4c0,0 -0.24,0.04 -0.16,-0.29c0.08,-0.33 0.03,-1.39 0,-1.75c-0.04,-0.36 0.07,-1.41 -0.74,-1.55c-0.55,-0.1 -0.62,0.05 -0.89,0.01c-0.27,-0.04 -0.59,-0.95 -1.1,-0.95zM19.93,12.65c0.49,0.53 0.46,3.32 0.46,3.32c2.24,0 5.62,0 5.62,0c0,0 -0.21,-1.96 -1.2,-2.5c-0.32,-0.29 -0.62,-0.82 -2.33,-1.05c-1.71,-0.24 -1.38,-1.07 -1.39,-1.12c0,-0.13 0.06,-0.67 0.06,-0.67c0,0 0.7,-0.43 0.96,-1.14c0.41,-0.25 0.11,-0.28 0.18,-0.56c0,0 0.16,-1.26 -0.18,-1.07c0,0 -0.32,0.03 -0.27,-0.22c0.06,-0.25 0.11,-1.06 0.08,-1.34c-0.03,-0.28 0.06,-1.08 -0.57,-1.19c-0.42,-0.07 -0.06,0.04 -0.27,0.01c-0.21,-0.03 -0.45,-0.39 -0.84,-0.39l-0.8,0.12c-0.39,0 -0.33,0.11 -0.53,0.14c-0.21,0.03 0.04,-0.03 -0.58,0.08c-0.62,0.11 -0.48,0.72 -0.51,1c-0.03,0.28 0.04,1 0.06,1.42c0.06,0.25 -0.14,0.35 -0.14,0.35c-0.37,-0.02 -0.21,1.07 -0.21,1.07c0.05,0.27 -0.08,0.4 0.47,0.61c0.26,0.71 0.67,1.06 0.67,1.06c0,0 0.02,0.49 0.03,0.81c0.67,0.37 0.9,0.8 1.23,1.27zM7.35,11.38c0.01,-0.32 0.02,-0.81 0.02,-0.81c0,0 0.56,-0.36 0.82,-1.06c0.55,-0.21 0.37,-0.34 0.42,-0.61c0,0 0.17,-1.1 -0.21,-1.07c0,0 -0.3,-0.1 -0.25,-0.35c0.02,-0.42 0.06,-1.14 0.03,-1.42c-0.03,-0.28 0.11,-0.89 -0.51,-1c-0.62,-0.11 -0.37,-0.06 -0.58,-0.08c-0.21,-0.03 -0.07,-0.14 -0.46,-0.14l-0.8,-0.12c-0.39,0 -0.63,0.36 -0.84,0.39c-0.21,0.03 0.16,-0.09 -0.27,-0.01c-0.62,0.11 -0.54,0.91 -0.57,1.19c-0.03,0.28 -0.05,1.09 0.01,1.34c0.06,0.25 -0.13,0.22 -0.13,0.22c-0.44,0 -0.4,0.94 -0.4,0.94c0.07,0.28 -0.09,0.45 0.32,0.7c0.26,0.71 0.96,1.14 0.96,1.14c0,0 -0.03,0.54 -0.03,0.67c-0.01,0.05 0.15,0.87 -1.3,1.12c-1.71,0.24 -2.01,0.76 -2.33,1.05c-1.27,0.67 -1.2,2.52 -1.2,2.52c0,0 3.39,0 5.62,0c0,0 0,-2.1 0.46,-3.33c0.34,-0.47 0.53,-0.9 1.2,-1.27z",
};

export const totalCompanies = {
  content: "Total Companies",
  value: 754,
  svg: "M3.11 28.13C2.77 28.13 2.49 28.41 2.49 28.75L2.49 29.98C2.49 30.32 2.77 30.6 3.11 30.6C3.45 30.6 3.73 30.32 3.73 29.98L3.73 28.75C3.73 28.41 3.45 28.13 3.11 28.13ZM3.11 31.83C2.77 31.83 2.49 32.11 2.49 32.45L2.49 33.68C2.49 34.02 2.77 34.3 3.11 34.3C3.45 34.3 3.73 34.02 3.73 33.68L3.73 32.45C3.73 32.11 3.45 31.83 3.11 31.83ZM3.11 24.43C2.77 24.43 2.49 24.71 2.49 25.05L2.49 26.28C2.49 26.62 2.77 26.9 3.11 26.9C3.45 26.9 3.73 26.62 3.73 26.28L3.73 25.05C3.73 24.71 3.45 24.43 3.11 24.43ZM5.59 28.13C5.25 28.13 4.97 28.41 4.97 28.75L4.97 29.98C4.97 30.32 5.25 30.6 5.59 30.6C5.93 30.6 6.21 30.32 6.21 29.98L6.21 28.75C6.21 28.41 5.93 28.13 5.59 28.13ZM5.59 24.43C5.25 24.43 4.97 24.71 4.97 25.05L4.97 26.28C4.97 26.62 5.25 26.9 5.59 26.9C5.93 26.9 6.21 26.62 6.21 26.28L6.21 25.05C6.21 24.71 5.93 24.43 5.59 24.43ZM5.59 31.83C5.25 31.83 4.97 32.11 4.97 32.45L4.97 33.68C4.97 34.02 5.25 34.3 5.59 34.3C5.93 34.3 6.21 34.02 6.21 33.68L6.21 32.45C6.21 32.11 5.93 31.83 5.59 31.83ZM35.38 7.78L34.14 7.78L34.14 5.93C34.14 5.59 33.86 5.32 33.52 5.32L29.8 5.32C29.46 5.32 29.18 5.59 29.18 5.93L29.18 7.78L27.94 7.78C27.59 7.78 27.32 8.06 27.32 8.4L27.32 18.27L26.69 18.27L26.69 16.42C26.69 16.08 26.42 15.8 26.07 15.8L25.45 15.8L25.45 15.18C25.45 14.84 25.18 14.57 24.83 14.57C24.49 14.57 24.21 14.84 24.21 15.18L24.21 15.8L23.59 15.8C23.25 15.8 22.97 16.08 22.97 16.42L22.97 18.27L21.11 18.27L21.11 5.93C21.11 5.59 20.83 5.32 20.49 5.32L18.63 5.32L18.63 1.62C18.63 1.28 18.35 1 18.01 1L10.56 1C10.21 1 9.94 1.28 9.94 1.62L9.94 5.32L8.07 5.32C7.73 5.32 7.45 5.59 7.45 5.93L7.45 21.97L6.21 21.97L6.21 20.12C6.21 19.78 5.93 19.5 5.59 19.5L1.87 19.5C1.52 19.5 1.25 19.78 1.25 20.12L1.25 21.97L0.63 21.97C0.28 21.97 0.01 22.24 0.01 22.58L0.01 37.38C0.01 37.72 0.28 38 0.63 38L8.07 38L13.04 38L27.94 38L35.38 38C35.73 38 36.01 37.72 36.01 37.38L36.01 8.4C36.01 8.06 35.73 7.78 35.38 7.78ZM17.38 8.4C17.38 8.06 17.66 7.78 18.01 7.78C18.35 7.78 18.63 8.06 18.63 8.4L18.63 18.27L17.38 18.27L17.38 8.4L17.38 8.4ZM14.9 4.08C14.9 3.74 15.18 3.47 15.52 3.47C15.86 3.47 16.14 3.74 16.14 4.08L16.14 5.93C16.14 6.27 15.86 6.55 15.52 6.55C15.18 6.55 14.9 6.27 14.9 5.93L14.9 4.08ZM14.9 8.4C14.9 8.06 15.18 7.78 15.52 7.78C15.86 7.78 16.14 8.06 16.14 8.4L16.14 18.27L14.9 18.27L14.9 8.4L14.9 8.4ZM12.42 4.08C12.42 3.74 12.7 3.47 13.04 3.47C13.38 3.47 13.66 3.74 13.66 4.08L13.66 5.93C13.66 6.27 13.38 6.55 13.04 6.55C12.7 6.55 12.42 6.27 12.42 5.93L12.42 4.08ZM9.94 8.4C9.94 8.06 10.21 7.78 10.56 7.78C10.9 7.78 11.18 8.06 11.18 8.4L11.18 21.97L9.94 21.97L9.94 8.4L9.94 8.4ZM12.42 35.53L10.56 35.53C10.21 35.53 9.94 35.26 9.94 34.92C9.94 34.58 10.21 34.3 10.56 34.3L12.42 34.3L12.42 35.53ZM12.42 33.07L10.56 33.07C10.21 33.07 9.94 32.79 9.94 32.45C9.94 32.11 10.21 31.83 10.56 31.83L12.42 31.83L12.42 33.07ZM12.42 30.6L10.56 30.6C10.21 30.6 9.94 30.32 9.94 29.98C9.94 29.64 10.21 29.37 10.56 29.37L12.42 29.37L12.42 30.6ZM12.42 28.13L10.56 28.13C10.21 28.13 9.94 27.86 9.94 27.52C9.94 27.18 10.21 26.9 10.56 26.9L12.42 26.9L12.42 28.13ZM12.42 24.43L8.07 24.43C7.73 24.43 7.45 24.71 7.45 25.05L7.45 36.77L1.25 36.77L1.25 23.2L1.87 23.2L5.59 23.2L8.07 23.2L10.56 23.2L12.42 23.2L12.42 24.43L12.42 24.43ZM12.42 18.88L12.42 8.4C12.42 8.06 12.7 7.78 13.04 7.78C13.38 7.78 13.66 8.06 13.66 8.4L13.66 18.27L13.04 18.27C12.7 18.27 12.42 18.54 12.42 18.88ZM27.32 36.77L26.07 36.77L26.07 21.35C26.07 21.01 25.8 20.73 25.45 20.73C25.11 20.73 24.83 21.01 24.83 21.35L24.83 36.77L23.59 36.77L23.59 21.35C23.59 21.01 23.31 20.73 22.97 20.73C22.63 20.73 22.35 21.01 22.35 21.35L22.35 36.77L21.11 36.77L21.11 21.35C21.11 21.01 20.83 20.73 20.49 20.73C20.15 20.73 19.87 21.01 19.87 21.35L19.87 36.77L18.63 36.77L18.63 21.35C18.63 21.01 18.35 20.73 18.01 20.73C17.66 20.73 17.38 21.01 17.38 21.35L17.38 36.77L16.14 36.77L16.14 21.35C16.14 21.01 15.86 20.73 15.52 20.73C15.18 20.73 14.9 21.01 14.9 21.35L14.9 36.77L13.66 36.77L13.66 34.92L13.66 32.45L13.66 29.98L13.66 27.52L13.66 25.05L13.66 22.58L13.66 19.5L15.52 19.5L18.01 19.5L20.49 19.5L23.59 19.5L26.07 19.5L27.32 19.5L27.32 36.77ZM31.04 34.42C31.04 34.76 30.76 35.04 30.42 35.04C30.08 35.04 29.8 34.76 29.8 34.42L29.8 33.19C29.8 32.85 30.08 32.57 30.42 32.57C30.76 32.57 31.04 32.85 31.04 33.19L31.04 34.42ZM31.04 30.72C31.04 31.06 30.76 31.34 30.42 31.34C30.08 31.34 29.8 31.06 29.8 30.72L29.8 29.49C29.8 29.15 30.08 28.87 30.42 28.87C30.76 28.87 31.04 29.15 31.04 29.49L31.04 30.72ZM31.04 27.02C31.04 27.36 30.76 27.64 30.42 27.64C30.08 27.64 29.8 27.36 29.8 27.02L29.8 25.79C29.8 25.45 30.08 25.17 30.42 25.17C30.76 25.17 31.04 25.45 31.04 25.79L31.04 27.02ZM31.04 23.32C31.04 23.66 30.76 23.94 30.42 23.94C30.08 23.94 29.8 23.66 29.8 23.32L29.8 22.09C29.8 21.75 30.08 21.47 30.42 21.47C30.76 21.47 31.04 21.75 31.04 22.09L31.04 23.32ZM31.04 19.62C31.04 19.96 30.76 20.24 30.42 20.24C30.08 20.24 29.8 19.96 29.8 19.62L29.8 18.39C29.8 18.05 30.08 17.77 30.42 17.77C30.76 17.77 31.04 18.05 31.04 18.39L31.04 19.62ZM31.04 15.92C31.04 16.26 30.76 16.54 30.42 16.54C30.08 16.54 29.8 16.26 29.8 15.92L29.8 14.69C29.8 14.35 30.08 14.07 30.42 14.07C30.76 14.07 31.04 14.35 31.04 14.69L31.04 15.92ZM31.04 12.22C31.04 12.56 30.76 12.84 30.42 12.84C30.08 12.84 29.8 12.56 29.8 12.22L29.8 10.99C29.8 10.65 30.08 10.37 30.42 10.37C30.76 10.37 31.04 10.65 31.04 10.99L31.04 12.22ZM33.52 34.42C33.52 34.76 33.24 35.04 32.9 35.04C32.56 35.04 32.28 34.76 32.28 34.42L32.28 33.19C32.28 32.85 32.56 32.57 32.9 32.57C33.24 32.57 33.52 32.85 33.52 33.19L33.52 34.42ZM33.52 30.72C33.52 31.06 33.24 31.34 32.9 31.34C32.56 31.34 32.28 31.06 32.28 30.72L32.28 29.49C32.28 29.15 32.56 28.87 32.9 28.87C33.24 28.87 33.52 29.15 33.52 29.49L33.52 30.72ZM33.52 27.02C33.52 27.36 33.24 27.64 32.9 27.64C32.56 27.64 32.28 27.36 32.28 27.02L32.28 25.79C32.28 25.45 32.56 25.17 32.9 25.17C33.24 25.17 33.52 25.45 33.52 25.79L33.52 27.02ZM33.52 23.32C33.52 23.66 33.24 23.94 32.9 23.94C32.56 23.94 32.28 23.66 32.28 23.32L32.28 22.09C32.28 21.75 32.56 21.47 32.9 21.47C33.24 21.47 33.52 21.75 33.52 22.09L33.52 23.32ZM33.52 19.62C33.52 19.96 33.24 20.24 32.9 20.24C32.56 20.24 32.28 19.96 32.28 19.62L32.28 18.39C32.28 18.05 32.56 17.77 32.9 17.77C33.24 17.77 33.52 18.05 33.52 18.39L33.52 19.62ZM33.52 15.92C33.52 16.26 33.24 16.54 32.9 16.54C32.56 16.54 32.28 16.26 32.28 15.92L32.28 14.69C32.28 14.35 32.56 14.07 32.9 14.07C33.24 14.07 33.52 14.35 33.52 14.69L33.52 15.92ZM33.52 12.22C33.52 12.56 33.24 12.84 32.9 12.84C32.56 12.84 32.28 12.56 32.28 12.22L32.28 10.99C32.28 10.65 32.56 10.37 32.9 10.37C33.24 10.37 33.52 10.65 33.52 10.99L33.52 12.22Z",
};

export const totalNewMember = {
  content: "New Monthly Members",
  value: 90,
};

export const WBATaken = {
  content: "HRA's Taken",
  value: "72%",
  svg: "M8,3.44c-4.32,-7.48 -15.61,3.63 0,12.56c15.61,-8.93 4.32,-20.03 0,-12.56z",
};

export const staticSurvey = [
  {
    id: 32,
    survey_name: "ANNUAL",
    start_date: "2020-09-09",
    end_date: "2020-09-30",
    survey_point: 25,
    description:
      "Annual Survey for Engagement, Leadership, Enablement, Alignment, Development.",
    image: "survey-image/lWRISbTHukUmrXq.png",
    has_sections: 1,
    launch_survey_for: 0,
    created_at: "2020-09-09T16:28:15.000000Z",
    updated_at: "2020-09-09T16:28:15.000000Z",
    data: [
      {
        title: "ENGAGEMENT",
        data: [
          {
            id: 272,
            question: "I am proud to work for [Company]",
            options: [
              {
                id: 1323,
                answer: "Strongly Agree",
              },
              {
                id: 1324,
                answer: "Agree",
              },
              {
                id: 1325,
                answer: "Neutral",
              },
              {
                id: 1326,
                answer: "Disagree",
              },
              {
                id: 1327,
                answer: "Strongly Disagree",
              },
            ],
          },
          {
            id: 273,
            question: "I would recommend [Company] as a great place to work",
            options: [
              {
                id: 1328,
                answer: "Strongly Agree",
              },
              {
                id: 1329,
                answer: "Agree",
              },
              {
                id: 1330,
                answer: "Neutral",
              },
              {
                id: 1331,
                answer: "Disagree",
              },
              {
                id: 1332,
                answer: "Strongly Disagree",
              },
            ],
          },
          {
            id: 274,
            question:
              "I rarely think about looking for a job at another company",
            options: [
              {
                id: 1333,
                answer: "Strongly Agree",
              },
              {
                id: 1334,
                answer: "Agree",
              },
              {
                id: 1335,
                answer: "Neutral",
              },
              {
                id: 1336,
                answer: "Disagree",
              },
              {
                id: 1337,
                answer: "Strongly Disagree",
              },
            ],
          },
          {
            id: 275,
            question:
              "I see myself still working at [Company] in two year’s time",
            options: [
              {
                id: 1338,
                answer: "Strongly Agree",
              },
              {
                id: 1339,
                answer: "Agree",
              },
              {
                id: 1340,
                answer: "Neutral",
              },
              {
                id: 1341,
                answer: "Disagree",
              },
              {
                id: 1342,
                answer: "Strongly Disagree",
              },
            ],
          },
          {
            id: 276,
            question:
              "[Company] motivates me to go beyond what I would in a similar role elsewhere",
            options: [
              {
                id: 1343,
                answer: "Strongly Agree",
              },
              {
                id: 1344,
                answer: "Agree",
              },
              {
                id: 1345,
                answer: "Neutral",
              },
              {
                id: 1346,
                answer: "Disagree",
              },
              {
                id: 1347,
                answer: "Strongly Disagree",
              },
            ],
          },
        ],
      },
      {
        title: "LEADERSHIP",
        data: [
          {
            id: 277,
            question:
              "The leaders at [Company] keep people informed about what is happening",
            options: [
              {
                id: 1348,
                answer: "Strongly Agree",
              },
              {
                id: 1349,
                answer: "Agree",
              },
              {
                id: 1350,
                answer: "Neutral",
              },
              {
                id: 1351,
                answer: "Disagree",
              },
              {
                id: 1352,
                answer: "Strongly Disagree",
              },
            ],
          },
          {
            id: 278,
            question: "My manager is a great role model for employees",
            options: [
              {
                id: 1353,
                answer: "Strongly Agree",
              },
              {
                id: 1354,
                answer: "Agree",
              },
              {
                id: 1355,
                answer: "Neutral",
              },
              {
                id: 1356,
                answer: "Disagree",
              },
              {
                id: 1357,
                answer: "Strongly Disagree",
              },
            ],
          },
          {
            id: 279,
            question: "I am proud to work for [Company]",
            options: [
              {
                id: 1358,
                answer: "Strongly Agree",
              },
              {
                id: 1359,
                answer: "Agree",
              },
              {
                id: 1360,
                answer: "Neutral",
              },
              {
                id: 1361,
                answer: "Disagree",
              },
              {
                id: 1362,
                answer: "Strongly Disagree",
              },
            ],
          },
        ],
      },
      {
        title: "ENABLEMENT",
        data: [
          {
            id: 280,
            question: "I have access to the things I need to do my job well",
            options: [
              {
                id: 1363,
                answer: "Strongly Agree",
              },
              {
                id: 1364,
                answer: "Agree",
              },
              {
                id: 1365,
                answer: "Neutral",
              },
              {
                id: 1366,
                answer: "Disagree",
              },
              {
                id: 1367,
                answer: "Strongly Disagree",
              },
            ],
          },
          {
            id: 281,
            question:
              "I have access to the learning and development I need to do my job well",
            options: [
              {
                id: 1368,
                answer: "Strongly Agree",
              },
              {
                id: 1369,
                answer: "Agree",
              },
              {
                id: 1370,
                answer: "Neutral",
              },
              {
                id: 1371,
                answer: "Disagree",
              },
              {
                id: 1372,
                answer: "Strongly Disagree",
              },
            ],
          },
          {
            id: 282,
            question:
              "Most of the systems and processes here support us getting our work done effectively",
            options: [
              {
                id: 1373,
                answer: "Strongly Agree",
              },
              {
                id: 1374,
                answer: "Agree",
              },
              {
                id: 1375,
                answer: "Neutral",
              },
              {
                id: 1376,
                answer: "Disagree",
              },
              {
                id: 1377,
                answer: "Strongly Disagree",
              },
            ],
          },
        ],
      },
      {
        title: "ALIGNMENT",
        data: [
          {
            id: 283,
            question: "I know what I need to be successful in my role",
            options: [
              {
                id: 1378,
                answer: "Strongly Agree",
              },
              {
                id: 1379,
                answer: "Agree",
              },
              {
                id: 1380,
                answer: "Neutral",
              },
              {
                id: 1381,
                answer: "Disagree",
              },
              {
                id: 1382,
                answer: "Strongly Disagree",
              },
            ],
          },
          {
            id: 284,
            question: "I receive appropriate recognition when I do good work",
            options: [
              {
                id: 1383,
                answer: "Strongly Agree",
              },
              {
                id: 1384,
                answer: "Agree",
              },
              {
                id: 1385,
                answer: "Neutral",
              },
              {
                id: 1386,
                answer: "Disagree",
              },
              {
                id: 1387,
                answer: "Strongly Disagree",
              },
            ],
          },
          {
            id: 285,
            question:
              "Day-to-day decisions here demonstrate the quality and improvement are top priorities",
            options: [
              {
                id: 1388,
                answer: "Strongly Agree",
              },
              {
                id: 1389,
                answer: "Agree",
              },
              {
                id: 1390,
                answer: "Neutral",
              },
              {
                id: 1391,
                answer: "Disagree",
              },
              {
                id: 1392,
                answer: "Strongly Disagree",
              },
            ],
          },
        ],
      },
      {
        title: "DEVELOPMENT",
        data: [
          {
            id: 286,
            question:
              "My manager (or someone in management) has shown a genuine interest in my career aspirations",
            options: [
              {
                id: 1393,
                answer: "Strongly Agree",
              },
              {
                id: 1394,
                answer: "Agree",
              },
              {
                id: 1395,
                answer: "Neutral",
              },
              {
                id: 1396,
                answer: "Disagree",
              },
              {
                id: 1397,
                answer: "Strongly Disagree",
              },
            ],
          },
          {
            id: 287,
            question:
              "I believe there are good career opportunities for me at this company",
            options: [
              {
                id: 1398,
                answer: "Strongly Agree",
              },
              {
                id: 1399,
                answer: "Agree",
              },
              {
                id: 1400,
                answer: "Neutral",
              },
              {
                id: 1401,
                answer: "Disagree",
              },
              {
                id: 1402,
                answer: "Strongly Disagree",
              },
            ],
          },
          {
            id: 288,
            question:
              "This is a great company for me to make a contribution to my development",
            options: [
              {
                id: 1403,
                answer: "Strongly Agree",
              },
              {
                id: 1404,
                answer: "Agree",
              },
              {
                id: 1405,
                answer: "Neutral",
              },
              {
                id: 1406,
                answer: "Disagree",
              },
              {
                id: 1407,
                answer: "Strongly Disagree",
              },
            ],
          },
        ],
      },
    ],
  },
];

export const groupActivityTypesItems = [
  "Total Group Distance",
  "Total Group Steps",
  "Total Group Calories",
];

export const activityTypesItems = [
  "Total Distance",
  "Total Steps",
  "Total Calories",
];

export const activityChallengeTypes = [
  "Classic challenge",
  "Survivor challenge",
  "Group Challenge",
];

export const challengeModeItems = ["Team", "Solo"];

export const recurringTypes = ["does not repeat", "weekly"];

export const eventsTierPoints = [
  { key: "Tier 1: 0 points", value: 0 },
  { key: "Tier 2: 25 points", value: 25 },
  { key: "Tier 3: 50 points", value: 50 },
  { key: "Tier 4: 100 points", value: 100 },
  { key: "Tier 5: 150 points", value: 150 },
  { key: "Tier 6: 200 points", value: 200 },
  { key: "Tier 7: 250 points", value: 250 },
  { key: "Tier 8: 300 points", value: 300 },
  { key: "Tier 9: 350 points", value: 350 },
  { key: "Tier 10: 400 points", value: 400 },
  { key: "Tier 11: 450 points", value: 450 },
  { key: "Tier 12: 500 points", value: 500 },
  { key: "Tier 13: 550 points", value: 550 },
  { key: "Tier 14: 600 points", value: 600 },
  { key: "Tier 15: 650 points", value: 650 },
  { key: "Tier 16: 700 points", value: 700 },
  { key: "Tier 17: 750 points", value: 750 },
  { key: "Tier 18: 800 points", value: 800 },
  { key: "Tier 19: 850 points", value: 850 },
  { key: "Tier 20: 900 points", value: 900 },
  { key: "Tier 21: 950 points", value: 950 },
  { key: "Tier 22: 1000 points", value: 1000 },
];

export const showEmailNotificationInfo = [
  "Emails will be sent as soon as you click Create Event.",
  "Email reminders will be sent 30 minutes before an event starts.",
  "Email notifications are sent the day after an event is completed to users who participated.",
];

export const surveyOptionTypes = [
  {
    key: "Scale",
    questionType: 1,
    options: [
      "Strongly Agree",
      "Agree",
      "Neutral",
      "Disagree",
      "Strongly Disagree",
    ],
  },
  { key: "MCQ", questionType: 2, options: [""] },
  { key: "Yes or No", questionType: 3, options: ["Yes", "No"] },
  { key: "Short Description", questionType: 4, options: [] },
];

export const challengePointItems = [
  "Tier 1: 25 points",
  "Tier 2: 100 points",
  "Tier 3: 250 points",
  "Tier 4: 500 points",
];

export const repeatValues = [
  "Repeat Every Day",
  "Repeat once",
  "Repeat Whole Week",
];

export const EditFitnessVideos = {
  fields: [
    {
      name: "muscle_group",
      type: "drop-down",
      label: "Wellness Focus:",
      placeholder: "None",
      key: "muscle_group",
      mandatory: true
    },
    {
      name: "fitness_level",
      type: "drop-down",
      label: "Fitness Level:",
      placeholder: "Select Fitness Level",
      key: "fitness_level",
      mandatory: true
    },
    {
      "name": "thumbnail_image",
      "type": "thumbnail",
      "label": "Video URL",
      "placeholder": "http",
      "pattern":"https?://.+",
      "mandatory": true,
    },
    {
      name: "video_url",
      type: "text",
      label: "Video URL:",
      placeholder: "http://",
      pattern: "https?://.+",
      mandatory: true
    },
  ],
  button: "Save Video",
  mandatoryFields: ["video_url", "title", "video_categories", "muscle_group"],
};

export const registrationAdditionalFields = {
  title: "Location ",
  name: "companyLocation",
};

export const registrationDepartmentFields = {
  title: "Department ",
  name: "department",
};

export const loginPageFields = [
  {
    title: "login to your account",
    type: "login",
    inputFields: [
      {
        type: "text",
        placeholder: "Enter Email Address",
        icon: "fa-user",
        name: "emailOrUsername",
        maxLength: 50,
        heading: "Your Email",
        link: "",
      },
      {
        type: "password",
        placeholder: "Enter Password",
        icon: "fa-lock",
        name: "loginPassword",
        maxLength: 200,
        heading: "Password",
        link: "Request A New Password?",
      },
    ],
    buttonText: "login",
    link: "Request new password?",
  },
  {
    title: "Register As A New User",
    type: "register",
    inputFields: [
      {
        type: "text",
        placeholder: "Enter Your Company Name",
        icon: "fa-user",
        name: "companyName",
        maxLength: 200,
        heading: "Company Name",
        link: "",
      },
      {
        type: "password",
        placeholder: "Enter Password",
        icon: "fa-lock",
        name: "companyPassword",
        maxLength: 200,
        heading: "Company Password",
        link: "",
      },
    ],
    buttonText: "register",
    link: "",
  },
  {
    title: "Log in with SSO",
    type: "sso",
    inputFields: [
      {
        type: "text",
        placeholder: "Enter Email Address",
        icon: "fa-user",
        name: "emailOrUsername",
        maxLength: 50,
        heading: "Your Email",
        link: "",
      },
    ],
    buttonText: "login",
    link: "",
  },
];

export const PeerRecognition = {
  fields: [
    {
      name: "addRecognition",
      type: "drop-down",
      label: "Add Recognition:",
      placeholder: "Select Recognition",
      key: "exemplifiesValues",
    },
  ],
};

export const generalHealthFirstColumn = [
  {
    title: "How Many Days Per Week Do You Exercise? *",
    name: "exercise_day_per_week",
    mandatory: true,
    values: [
      "0 Day",
      "1 Day",
      "2 Days",
      "3 Days",
      "4 Days",
      "5 Days",
      "6 Days",
      "7 Days",
    ],
  },
  {
    title: "Do You Smoke? *",
    name: "smoke",
    mandatory: true,
    values: [
      "Yes (Heavy smoker)",
      "Yes (Casual smoker / Trying to quit)",
      "No (I don't smoke at all)",
    ],
  },
  {
    title: "Physical Exam Frequency: *",
    name: "physical_exam_frequency",
    mandatory: true,
    values: ["Every 5+ Year", "Every 3+ Year", "Every 1+ Year", "Every Year"],
  },
  {
    title: "Average Sleep Per Night? *",
    name: "average_sleep",
    mandatory: true,
    values: ["9 Hrs", "8 Hrs", "7 Hrs", "6 Hrs Or Less"],
  },
];

export const generalHealthSecondColumn = [
  {
    title: "Average Water Intake Per Day? *",
    name: "average_water_intake",
    mandatory: true,
    values: [
      "20 Ounces Or Less",
      "20 - 40 Ounces",
      "40 - 60 Ounces",
      "60 - 80 Ounces",
      "80 Ounces Or More",
    ],
  },
  {
    title: "How Often Do You Experience Pain In Your Body? *",
    name: "pain_experience",
    mandatory: true,
    values: ["Daily", "Weekly", "Monthly", "Annually", "Rarely Or Never"],
  },
  {
    title: "How Many Prescription Drugs Do You Take Daily? *",
    name: "prescription_intake",
    mandatory: true,
    values: ["0", "1", "2", "3+"],
  },
];

export const wellnessSportsFirstColumn = [
  "individual sports",
  "water sports",
  "ball sports",
  "wheel sports",
];

export const wellnessSportsSecondColumn = [
  "winter sports",
  "combat sports",
  "resistance training",
  "other",
];

export const challengeTierPoints=[
  {"key": "No Points", "value": 0},
  {"key": "25 Points", "value": 25},
  {"key": "50 Points", "value": 50},
  {"key": "100 Points", "value": 100},
  {"key": "150 Points", "value": 150},
  {"key": "200 Points", "value": 200},
  {"key": "250 Points", "value": 250},
  {"key": "300 Points", "value": 300},
  {"key": "350 Points", "value": 350},
  {"key": "400 Points", "value": 400},
  {"key": "450 Points", "value": 450},
  {"key": "500 Points", "value": 500},
  {"key": "550 Points", "value": 550},
  {"key": "600 Points", "value": 600},
  {"key": "650 Points", "value": 650},
  {"key": "700 Points", "value": 700},
  {"key": "750 Points", "value": 750},
  {"key": "800 Points", "value": 800},
  {"key": "850 Points", "value": 850},
  {"key": "900 Points", "value": 900},
  {"key": "950 Points", "value": 950},
  {"key": "1000 Points", "value": 1000},
]






export const wellnessChallengePoints=[
  // {"key": "No Points", "value": 0},
  {"key": "5 points", "value": 5},
  {"key": "10 points", "value": 10},
  {"key": "15 points", "value": 15},
  {"key": "20 points", "value": 20},
  {"key": "25 points", "value": 25},
]

export const createWellnessWeeks = [
  {
    "name": "1 Week",
    "value":"1"
  },
  {
    "name": "2 Weeks",
    "value":"2"
  },
  {
    "name": "3 Weeks",
    "value":"3"
  },
  {
    "name": "4 Weeks",
    "value":"4"
  },
  {
    "name": "5 Weeks",
    "value":"5"
  },
  {
    "name": "6 Weeks",
    "value":"6"
  },
  {
    "name": "7 Weeks",
    "value":"7"
  }
]

export const wellnessCategories = [
  {
    "name": "Nutrition Challenge",
    "value":"nutrition"
  },
  {
    "name": "Fitness Challenge",
    "value":"fitness"
  },
  {
    "name": "Workplace Challenge",
    "value":"workplace"
  },
  {
    "name": "Stress Challenge",
    "value":"stress"
  },
  {
    "name": "Health Challenge",
    "value":"health"
  },
  {
    "name": "Lifestyle Challenge",
    "value":"lifestyle"
  }
]

export const region =[
  {"key": "North America", "value": "North America"},
  {"key": "South America", "value": "South America"},
  {"key": "APAC", "value": "APAC"},
  {"key": "MENA", "value": "MENA"},
  {"key": "Europe", "value": "Europe"}
]

export const companySize = [
  {"key": "1-100", "value": "1-100"},
  {"key": "101-200", "value": "101-200"},
  {"key": "201-500", "value": "201-500"},
  {"key": "501-1000", "value": "501-1000"},
  {"key": "1001-5000", "value": "1001-5000"},
  {"key": "5000+", "value":  "5000+"}
]

export const behaviorChallengePointValues = [
  {"key": "10", "value": "10 Points"},
  {"key": "25", "value": "25 Points"},
  {"key": "100", "value": "100 Points"},
  {"key": "250", "value": "250 Points"},
  {"key": "500", "value": "500 Points"}
]

export const selectBehaviorLevel = [
  {"key": "Level 1", "value": "Level 1"},
  {"key": "Level 2", "value": "Level 2"},
  {"key": "Level 3", "value": "Level 3"},
  {"key": "Level 4", "value": "Level 4"},
  {"key": "Level 5", "value": "Level 5"}
]


export const featuredMonths = [
  {
    "name": "No feature month",
    "key": "none",
    "id":0
  },
  {
    "name": "January",
    "key": "january",
    "id":1
  },
  {
    "name": "February",
    "key": "february",
    "id":2
  },
  {
    "name": "March",
    "key": "march",
    "id":3
  },
  {
    "name": "April",
    "key": "april",
    "id":4
  },
  {
    "name": "May",
    "key": "may",
    "id":5
  },
  {
    "name": "June",
    "key": "june",
    "id":6
  },
  {
    "name": "July",
    "key": "july",
    "id":7
  },
  {
    "name": "August",
    "key": "august",
    "id":8
  },
  {
    "name": "September",
    "key": "september",
    "id":9
  },
  {
    "name": "October",
    "key": "october",
    "id":10
  },
  {
    "name": "November",
    "key": "november",
    "id":11
  },
  {
    "name": "December",
    "key": "december",
    "id":12
  }
];





export const months = [
  {
    "name": "January",
    "key": "january",
    "id":1
  },
  {
    "name": "February",
    "key": "february",
    "id":2
  },
  {
    "name": "March",
    "key": "march",
    "id":3
  },
  {
    "name": "April",
    "key": "april",
    "id":4
  },
  {
    "name": "May",
    "key": "may",
    "id":5
  },
  {
    "name": "June",
    "key": "june",
    "id":6
  },
  {
    "name": "July",
    "key": "july",
    "id":7
  },
  {
    "name": "August",
    "key": "august",
    "id":8
  },
  {
    "name": "September",
    "key": "september",
    "id":9
  },
  {
    "name": "October",
    "key": "october",
    "id":10
  },
  {
    "name": "November",
    "key": "november",
    "id":11
  },
  {
    "name": "December",
    "key": "december",
    "id":12
  }
];

export const healthProgramWeeks = [
  // {
  //   name: "None",
  //   value:0
  // },
  {
    name: "1 Week",
    value:1
  },
  {
    "name": "2 Weeks",
    value:2
  },
  {
    name: "3 Weeks",
    value:3
  },
  {
    name: "4 Weeks",
    value:4
  }
];

export const healthProgramMonths = [
  // {
  //   name: "None",
  //   value:0
  // },
  {
    name: "1 Month",
    value:1
  },
  {
    "name": "2 Months",
    value:2
  },
  {
    name: "3 Months",
    value:3
  },
  {
    name: "4 Months",
    value:4
  },
  {
    name: "5 Months",
    value:5
  },
  {
    name: "6 Months",
    value:6
  },
  {
    name: "7 Months",
    value:7
  },
  {
    name: "8 Months",
    value:8
  },
  {
    name: "9 Months",
    value:9
  },
  {
    name: "10 Months",
    value:10
  },
  {
    name: "11 Months",
    value:11
  },
  {
    name: "12 Months",
    value:12
  }
]

export const surveyWholeQuizTime = [
  { key: "5 Minutes", value: 300 },
  { key: "10 Minutes", value: 600 },
  { key: "15 Minutes", value: 900 },
  { key: "20 Minutes", value: 1200 },
  { key: "25 Minutes", value: 1500 },
  { key: "30 Minutes", value: 1800 },
  { key: "35 Minutes", value: 2100 },
  { key: "40 Minutes", value: 2400 },
  { key: "45 Minutes", value: 2700 },
  { key: "50 Minutes", value: 3000 },
  { key: "55 Minutes", value: 3300 },
  { key: "60 Minutes", value: 3600 }
];

export const surveyPerQuestionTime = [
  { key: "15 Seconds", value: 15 },
  { key: "30 Seconds", value: 30 },
  { key: "45 Seconds", value: 45 },
  { key: "60 Seconds", value: 60 },
  { key: "75 Seconds", value: 75 },
  { key: "90 Seconds", value: 90 },
  { key: "2 Minutes", value: 120 },
  { key: "3 Minutes", value: 180 }
];

export const bannerThemeData = [
  {
    "themeBackground": "/admin-page/Jan.png",
    "themeText": "Self-Improvement Month",
    "color": "#B54D93"
  },
  {
    "themeBackground": "/admin-page/February.png",
    "themeText": "Heart Health Month",
    "color": "#A62F3D"
  },
  {
    "themeBackground": "/admin-page/March.png",
    "themeText": "Complete Wellbeing",
    "color": "#8D7D41"
  },
  {
    "themeBackground": "/admin-page/April.png",
    "themeText": "Active Living Month",
    "color": "#D7442B"
  },
  {
    "themeBackground": "/admin-page/May.png",
    "themeText": "Mental Health Awareness Month",
    "color": "#8D4964"
  },
  {
    "themeBackground": "/admin-page/June.png",
    "themeText": "Workplace Wellbeing and Occupational Health",
    "color": "#2F6C42"
  },
  {
    "themeBackground": "/admin-page/July.png",
    "themeText": "Social Wellness and Connection",
    "color": "#A62F3D"
  },
  {
    "themeBackground": "/admin-page/August.png",
    "themeText": "Physical Fitness and Longevity",
    "color": "#6A73C1"
  },
  {
    "themeBackground": "/admin-page/September.png",
    "themeText": "Financial Wellness and Planning",
    "color": "#C06236"
  },
  {
    "themeBackground": "/admin-page/October.png",
    "themeText": "Mindfulness and Spiritual Wellness",
    "color": "#6A73C1"
  },
  {
    "themeBackground": "/admin-page/November.png",
    "themeText": "Environmental Wellness and Sustainability",
    "color": "#2F6C42"
  },
  {
    "themeBackground": "/admin-page/December.png",
    "themeText": "Reflect and Recharge",
    "color": "#B54D93"
  }
]

export const getLanguages = [
  {
    "name": "en",
    "display_name": "english",
    "image": "language/english.png",
    "user_selected": 1
  },
  {
    "name": "es",
    "display_name": "spanish",
    "image": "language/spanish.png",
    "user_selected": 0
  },
  {
    "name": "fr",
    "display_name": "french",
    "image": "language/french.png",
    "user_selected": 0
  },
  {
    "name": "pt",
    "display_name": "portuguese",
    "image": "language/portuguese.png",
    "user_selected": 0
  }
];

export const FONT_SIZE_MAP = {
  Small: "14px",
  Medium: "16px",
  Large: "20px",
  "Extra Large": "28px",
};

export const FONT_SIZE_OPTIONS = Object.keys(FONT_SIZE_MAP);

export const WellnessTabs = [{id:1,tab:'Articles',category:'article'},{id:2,tab:'Fitness',category:'fitness_video'},{id:3,tab:'Recipes',category:'recipe'}]
